module.exports = __webpack_public_path__ + "static/media/login.5672d0aa.svg";